import React, { useCallback, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';
import { initializeExoSkeletonRuntimeValues, isInExoSkeleton } from '@adsk/exo-skeleton-api';
const RemotesContext = getOrCreateGlobalContext(CONTEXT_NAMES.ExoSkeletonRemotesContext);
export const useRemotes = () => useContext(RemotesContext);
const useRemotesInitialization = initializeCallback => {
  const [isLoading, setIsLoading] = useState(!isInExoSkeleton());
  const [error, setError] = useState(null);
  useLayoutEffect(() => {
    async function initialize() {
      try {
        await initializeCallback();
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    }
    initialize();
  }, [initializeCallback]);
  return {
    isLoading,
    error
  };
};
const defaultGetRemoteOverride = scope => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has(scope)) {
    return {
      url: urlParams.get(scope)
    };
  } else {
    return null;
  }
};
export const RemotesProvider = _ref => {
  let {
    children,
    environmentConfig: {
      env,
      region
    } = {},
    getRemoteOverride = defaultGetRemoteOverride,
    transformRemotesUrl
  } = _ref;
  const initializeCallback = useCallback(() => initializeExoSkeletonRuntimeValues({
    environmentConfig: {
      env,
      region
    },
    getRemoteOverride,
    transformRemotesUrl
  }), [env, region, getRemoteOverride, transformRemotesUrl]);
  const {
    isLoading,
    error
  } = useRemotesInitialization(initializeCallback);
  const value = useMemo(() => ({
    isLoading
  }), [isLoading]);
  if (error) {
    throw error;
  }
  return /*#__PURE__*/React.createElement(RemotesContext.Provider, {
    value: value
  }, children);
};
//# sourceMappingURL=RemotesProvider.js.map